import DateTime from "../../lib/dateTime.js"

export default class UserLite {
	id = null
	number = null
	name = null
	email = null
	emailBounced = false
	emailComplained = false
	emailVerified = false
	avatar = null
	hasSetAvatar = false
	bornOn = null
	isAdmin = false
	certification = new UserLite.Certification();
	rso = new UserLite.RSO();
	map = new UserLite.MAP();
	membership = new UserLite.Membership();
	insurance = new UserLite.Insurance();
	
	// Keep in sync with userView
	get isComplete()
	{
		return this.bornOn != null
				&& this.hasSetAvatar;
	}

	get canBeEmailed()
	{
		return !this.emailBounced;
	}

	get age()
	{
		if(!this.bornOn)
			return null;

		var today = DateTime.today;
		var age = today.year - this.bornOn.year;
		var m = today.month - this.bornOn.month;
		if (m < 0 || (m === 0 && today.day < this.bornOn.day))
			age--;
		
		return age;
	
	}

	static Certification = class {
		
		get level()
		{
			if(this.level3)
				return 'level3';

			if(this.level2)
				return 'level2';
			
			if(this.level1)
				return 'level1';
			
			return null;
		}

		level1 = false
		level2 = false
		level3 = false
	}

	static RSO = class {
		model = false
		level1 = false
		level2 = false
		level3 = false
	}

	static MAP = class {
		// This property is used in a Migration inside Mapping.js.
		// Adjust the migration if you remove/rename this
		attemptPending = false
	}

	static Membership = class {
		startedOn = null
		expiresOn = null
		
		get status()
		{
			if(this.startedOn == null)
				return 'non-member'
			
			if(this.expiresOn != null && this.expiresOn < DateTime.now)
				return 'expired'

			return 'active';
		}
	}
	
	static Insurance = class {
		status = 'unknown'
		BMFANumber = null
	}

}